module.exports = __webpack_public_path__ + "media/show-win-amount.4ccd5a41.mp3";